<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">STANJE SKLADIŠTA</h2>
  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div>
        <label>Odabir skladišta:</label>
        <dx-select-box
          #selectBoxSkladisteSirovina
          [disabled]="false"
          [items]="svaSkladista"
          [value]="svaSkladista[0].idposlovnica"
          valueExpr="idposlovnica"
          displayExpr="po_naziv_prikaz"
          [width]="500"
          (onValueChanged)="promjenaSkladista($event)"
        >
        </dx-select-box>
      </div>
    </div>
    <div class="customTable dnevniPlan">
      <dx-data-grid
        [dataSource]="stanjeSkladista"
        [wordWrapEnabled]="true"
        [showColumnLines]="true"
        noDataText="{{ poruka }}"
        keyExpr="sifra"
        [showBorders]="false"
        (onToolbarPreparing)="onToolbarPreparing($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'">
          <div class="naslov">
            <h2 class="mb-0">Stanje po skladištima</h2>
            <p class="mt-0">Praćenje stanja po skladištima</p>
          </div>
        </div>

        <dxo-search-panel
          [visible]="true"
          [width]="240"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxo-grouping [autoExpandAll]="false"></dxo-grouping>

        <dxi-column
          dataField="sifra"
          caption="Šifra"
          [width]="150"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="naziv"
          caption="Naziv skladišta"
          [groupIndex]="0"
        ></dxi-column>
        <dxi-column
          dataField="naziv_firme"
          caption="Naziv firme"
          [width]="150"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="sifraArtikla"
          caption="Šifra proizvoda"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="nazivArtikla"
          caption="Naziv proizvoda"
          sortOrder="asc"
        ></dxi-column>
        <dxi-column
          dataField="komada"
          caption="Komadno"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="paleta"
          caption="Paletno"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="datumPromjene"
          caption="Datum izmjene"
          [width]="150"
          alignment="center"
        ></dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>
